import { Component, Input, Output, EventEmitter } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { Alert } from '../models/alert.model';
@Component({
  standalone: true,
  selector: 'app-gas-price-alert-viewer',
  templateUrl: './gas-price-alert-viewer.component.html',
  styleUrls: ['./gas-price-alert-viewer.component.scss'],
  imports: [TranslateModule, CommonModule]
})
export class GasPriceAlertViewerComponent {
  @Input() alert!: Alert;

  @Input() isArabicLang: boolean = false;
  @Input() isLoading: boolean = false;

  @Output() reactivateAlert = new EventEmitter<any>();
  @Output() goToSwap = new EventEmitter<any>();
  @Output() removeAlert = new EventEmitter<any>();

  // Optionnel : à personnaliser avec ton propre mapping des icônes par chaîne
  CHAIN_MAP: Record<number, { icon: string; name: string }> = {
    1: { icon: 'assets/chains/ethereum-eth-logo.svg', name: 'Ethereum' },
    42161: { icon: 'assets/chains/arbitrum-arb-logo.svg', name: 'Arbitrum' },
    137: { icon: 'assets/chains/polygon-matic-logo.svg', name: 'Polygon' },
    // ajoute d'autres chaînes au besoin
  };
}
